
 <h3 class="popover-header" *ngIf="title">{{title}}</h3>
 <div class="popover-body">
 <ng-content></ng-content>
 </div>


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/free/popover/popover-container.component.ts.PopoverContainerComponent.html